/**
 * @ngdoc    component
 * @module   csm.ui.fields
 * @name     csm.ui.fields.component:styledCheckbox
 * @property {Boolean} ngModel  Model to update.
 * @description
 * Stylized checkbox replaces the default checkbox with a styled SPAN. Taken
 * largely from <https://www.w3schools.com/howto/howto_css_custom_checkbox.asp>.
 *******************************************************************************/
export const styledCheckboxComponent = {
  bindings: { label: '@', model: '=ngModel', disabled: '=ngDisabled' },
  require: 'ngModel',
  transclude: true,
  template:
    '<label ng-style="!!$ctrl.disabled ? {cursor:\'default\'} : null"><ng-transclude></ng-transclude>' +
    '<input style="height:0px; width:0px" type="checkbox" ' +
    'ng-model="$ctrl.model" ng-disabled="$ctrl.disabled" ' +
    'ng-change="$ctrl.ngModel.$setViewValue($ctrl.model)"/><span></span>' +
    '</label>'
};
